import { ErrorHandler, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HttpErrorResponse, provideHttpClient, withJsonpSupport } from '@angular/common/http';

import { CustomersRoutingModule } from './customers-routing.module';

import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NgOtpInputModule } from 'ng-otp-input';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ForumComponent } from './forum/forum.component';
import { ForumProfilePopupComponent } from './forum/profile-popup/profile-popup.component';
import { PollComponent } from './forum/poll/poll.component';
import { GiveawayComponent } from './forum/giveaway/giveaway.component';
import { GiveawaySurveyComponent } from './forum/giveaway/giveaway-survey/giveaway-survey.component';
import { NotificationComponent } from './marketplace/notification/notification.component';
import { NotificationBookingComponent } from './marketplace/notification/notification-booking/notification-booking.component';
import { ShareModule } from 'src/app/shareModule/shareModule';
import { MarketplaceProfileCharacterComponent } from './layout/component-layout/profile-character/marketplace-profile-character.component';
import { GoogleMapComponent } from './marketplace/google-map/google-map.component';
import { ClickOutsideDirective } from '../shareModule/directive/ngbd-click-outside/ngbd-click-outside.directive';
import { CommonFooterComponent } from './common/common-footer/common-footer/common-footer.component';
import { SingleNewComponent } from './news/single-new/single-new.component';
import { FormNewComponent } from './news/form-new/form-new.component';
import { MarketplacePageComponent } from './marketplace/marketplace.component';
import { MarketplaceShopDetailComponent } from './marketplace/shop-detail/marketplace-shop-detail.component';
import { NewsComponent } from './news/news.component';
import { BulletinComponent } from './news/bulletin/bulletin.component';
import { CustomersLayoutComponent } from './layout/customers-layout/customers-layout.component';
import { CustomersLayoutReferralComponent } from './layout/customers-layout-referral/customers-layout-referral.component';
import { ChatComponent } from 'src/app/shareModule/component/chat/chat.component';
import { ChatBotComponent } from 'src/app/shareModule/component/chat/chatbot/chatbot.component';
import { ChatLearnComponent } from 'src/app/shareModule/component/chat/chatlearn/chat-learn.component';
import { ChatMemoryComponent } from 'src/app/shareModule/component/chat/chatmemory/chat-memory.component';
import { RolesComponent } from './community/roles/roles.component';
import { TabForumComponent } from './forum/tab-forum/tab-forum.component';
import { MemberPageComponent } from './community/member-page/member-page.component';
import { CommunitySearchComponent } from './community/community-search/community-search.component';
import { CommunityProfileComponent } from './community/profile/profile.component';
import { HeaderSearchMapComponent } from './community/filter-products/header-search-map/header-search-map.component';
import { FilterProductsComponent } from './community/filter-products/filter-products.component';
import { SearchComponent } from './community/search/search.component';
import { ProfileMeComponent } from './community/member-page/me/profile-me/profile-me.component';
import { AskMeComponent } from './community/member-page/me/ask-me/ask-me.component';
import { NewsMeComponent } from './community/member-page/me/news-me/news-me.component';
import { AddMeComponent } from './community/member-page/me/add-me/add-me.component';
import { NearbyproductsMeComponent } from './community/member-page/me/nearbyproducts-me/nearbyproducts-me.component';
import { MemberProfileCharacterComponent } from './marketplace/member-profile-character/member-profile-character.component';
import { EventsComponent } from './community/events/events.component';
import { OnlineToggleButtonComponent } from './online-toggle-button/online-toggle-button.component';
import { IndividualRentalComponent } from './community/member-page/me/nearbyproducts-me/individual-rental/individual-rental.component';
import { IndividualAllProductComponent } from './community/member-page/me/nearbyproducts-me/individual-all-product/individual-all-product.component';
import { IndividualFreeComponent } from './community/member-page/me/nearbyproducts-me/individual-free/individual-free.component';
import { IndividualServicesComponent } from './community/member-page/me/nearbyproducts-me/individual-services/individual-services.component';
import { IndividualEventsComponent } from './community/member-page/me/nearbyproducts-me/individual-events/individual-events.component';
import { OtherCommuntyPageComponent } from './community/other-communty-page/other-communty-page.component';
import { BuyComponent } from './community/other-communty-page/buy/buy.component';
import { SellComponent } from './community/other-communty-page/sell/sell.component';
import { ReferComponent } from './community/other-communty-page/refer/refer.component';
import { WriteArticlesComponent } from './community/other-communty-page/write-articles/write-articles.component';
import { MarketplaceProfileComponent } from './layout/component-layout/marketplace-profile/marketplace-profile.component';
import { LevelProfileComponent } from './layout/component-layout/profile-character/level-profile/level-profile.component';
import { AvatarProfileComponent } from './layout/component-layout/profile-character/avatar-profile/avatar-profile.component';
import { StoreProfileComponent } from './layout/component-layout/profile-character/store-profile/store-profile.component';
import { MyTabsComponent } from './layout/component-layout/my-tabs/my-tabs.component';
import { MemberShopComponent } from './layout/component-layout/member-shop/member-shop.component';
import { LoudspeakerShopComponent } from './layout/component-layout/loudspeaker-shop/loudspeaker-shop.component';
import { TimerComponent } from './community/events/timer/timer.component';
import { ShopPageComponent } from './shop-page/shop-page.component';
import { HowToEarnComponent } from './community/other-communty-page/how-to-earn/how-to-earn.component';
import { SignInComponent } from './layout/component-layout/sign-in/sign-in.component';
import { TermsOfServiceComponent } from './community/other-communty-page/terms-of-service/terms-of-service.component';
import { TermsOfRentalComponent } from './community/other-communty-page/terms-of-rental/terms-of-rental.component';
import { MemberRegionSelectModalComponent } from './common/common-member-region-select-modal/member-region-select-modal.component';
import { MemberProfileRolesComponent } from './layout/component-layout/profile-character/member-profile-roles/member-profile-roles.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CarouselMiniCardComponent } from './news/carousel-mini-card/carousel-mini-card.component';
import { SettingProfileComponent } from './layout/component-layout/setting-profile/setting-profile.component';
import { DiamondsPopupComponent } from './layout/component-layout/profile-character/level-profile/diamonds-popup/diamonds-popup.component';
import { OtpInputComponent } from './layout/component-layout/sign-in/otp-input/otp-input.component';
import { PDPAPolicyComponent } from './layout/component-layout/sign-in/pdpa-policy/pdpa-policy.component';
import { ViewProductDetailsComponent } from './marketplace/view-product-details/view-product-details.component';
import { SurveyComponent } from './layout/component-layout/survey/survey.component';
import { AroundeMeComponent } from './community/member-page/me/around-me/around-me.component';
import { DropdownStatusComponent } from './layout/component-layout/dropdown-status/dropdown-status.component';
import { JobCompleteCofirmationModalComponent } from './job-complete-cofirmation-modal/job-complete-cofirmation-modal.component';
import { SideLeftMenuComponent } from './layout/component-layout/side-left-menu/side-left-menu.component';
import { MarketplaceProductComponent } from './marketplace/marketplace-product/marketplace-product.component';
import { ManualReviewTaskComponent } from './community/search/manual-review-task/manual-review-task.component';
import {
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
  HammerModule,
} from '@angular/platform-browser';

export class MyHammerConfig extends HammerGestureConfig {
  override overrides = {
    swipe: {
      threshold: 50,
    },
  };
}

import { AdvancedSettingsComponent } from './advanced-settings/advanced-settings.component';
import { AdvancedSettingsReferralComponent } from './advanced-settings-referral/advanced-settings-referral.component';
import { FaqComponent } from './faq/faq.component';
import { FaqItemComponent } from './faq/faq-item/faq-item.component';

import { ImageModalComponent } from '../shareModule/component/chat/chatbot/image-modal.component';
import { AllNotificationsModalComponent } from './marketplace/notification/all-notifications-modal.component';
import { ReportChatMessageModalComponent } from '../shareModule/component/chat/chatbot/report-modal.component';
import { PatchNoteComponent } from './customer-footer/patch-note/patch-note.component';
// import { NgxPopperjsModule } from 'ngx-popperjs';
import { BizOwnerPopupComponent } from './marketplace/view-product-details/biz-owner-popup/biz-owner-popup.component';
import { CommunityTrendingComponent } from './community/community-trending/community-trending.component';
import { BizCardComponent } from './biz-card/biz-card.component';
import { BizNameCardComponent } from './biz-name-card/biz-name-card.component';
import { RecommendationsFormComponent } from './community/recommandations-form/recommandations-form.component';
import { RecommendPageComponent } from './recommend-page/recommend-page.component';
import { BizLayoutComponent } from './biz-layout/biz-layout.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { VidplayerComponent } from './community/vidplayer/vidplayer.component';
import { LinkShareComponent } from './link-share/link-share.component';
import { SiteLinksComponent } from './community/site-links/site-links.component';
import { TagSelectorComponent } from './community/tag-selector/tag-selector.component';
import { ProductFaqListComponent } from './product-faq-list/product-faq-list.component';
import { ProductTypesListComponent } from './product-types-list/product-types-list.component';
import { CroppedImageComponent } from './cropped-image/cropped-image.component';
import { VerifyEmailPopupComponent } from '../shareModule/component/verify-email-popup/verify-email-popup.component';
import { BreadcrumbComponent } from '../shareModule/component/breadcrumb/breadcrumb.component';
import { SingleForumComponent } from './forum/tab-forum/single-forum/single-forum.component';
import { CompareProductListComponent } from './compare-product-list/compare-product-list.component';
import { FormForumComponent } from './forum/tab-forum/form-forum/form-forum.component';
import { SelectForumModalComponent } from '../select-forum-modal/select-forum-modal.component';
import { SelectProductToAttachComponent } from '../select-product-to-attach/select-product-to-attach.component';
import { ForumListComponent } from './forum-list/forum-list.component';
import { UploadEditedImageComponent } from '../community/upload-edited-image/upload-edited-image.component';
import { AdvancedSettingsIntroComponent } from './advanced-settings/advanced-settings-intro/advanced-settings-intro.component';
import { AdvancedSettingsContributionComponent } from './advanced-settings/advanced-settings-contribution/advanced-settings-contribution.component';
import { NewsForumComponent } from './forum/tab-forum/news-forum/news-forum.component';
import { NearbyAllServicesComponent } from './community/member-page/me/nearbyproducts-me/all-services/all-services.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ProductReviewComponent } from './community/search/product-review/product-review.component';
import { AdvancedSettingsProfileComponent } from './advanced-settings/advanced-settings-profile/advanced-settings-profile.component';
import { AdvancedSettingsPasswordComponent } from './advanced-settings/advanced-settings-password/advanced-settings-password.component';
import { AdvancedSettingsVerifyComponent } from './advanced-settings/advanced-settings-verify/advanced-settings-verify.component';
import { AdvancedSettingsPreferencesComponent } from './advanced-settings/advanced-settings-preferences/advanced-settings-preferences.component';
import { AdvancedSettingsTagsComponent } from './advanced-settings/advanced-settings-tags/advanced-settings-tags.component';
import { AdvancedSettingsSuperSellerComponent } from './advanced-settings/advanced-settings-super-seller/advanced-settings-super-seller.component';
import { AdvancedSettingsSuperSellerSettingsComponent } from './advanced-settings/advanced-settings-super-seller-settings/advanced-settings-super-seller-settings.component';
import { AdvancedSettingsChatComponent } from './advanced-settings/advanced-settings-chat/advanced-settings-chat.component';
import { AdvancedSettingsSeoComponent } from './advanced-settings/advanced-settings-seo/advanced-settings-seo.component';
import { MyProductEditComponent } from './my-product-edit/my-product-edit.component';
import { RecommendationCardComponent } from './recommendation-card/recommendation-card.component';
import { AdvancedSettingsCheckoutHistoryComponent } from './advanced-settings/advanced-settings-checkout-history/advanced-settings-checkout-history.component';
import { SelectRegionComponent } from '../select-region/select-region.component';
import { NearbyMapComponent } from '../nearby-map/nearby-map.component';
import { CustomizationColorsComponent } from '../nearby-map/customization-colors/customization-colors.component';
// import { ShowBookingsComponent } from '../nearby-map/show-bookings/show-bookings.component';
import { SearchSuggestionComponent } from '../search-suggestion/search-suggestion.component';
import { MenuOptionsComponent } from './layout/customers-layout/menu-options/menu-options.component';
import { CustomizationComponent } from './layout/component-layout/customization/customization.component';
import { ProfileNewsComponent } from './community/profile/profile-news/profile-news.component';
import { PromoCardComponent } from '../promo-card/promo-card.component';
import { WhatIsKachiingComponent } from './community/other-communty-page/what-is-kachiing/what-is-kachiing.component';
import { CommunityYoutubeComponent } from './community/community-youtube/community-youtube.component';
import { CommunityEatComponent } from './community/community-eat/community-eat.component';
import { CommunitySpecialTopicComponent } from './community/community-special-topic/community-special-topic.component';
import { PollCardComponent } from '../poll-card/poll-card.component';
import { PollFormComponent } from '../poll-form/poll-form.component';
import { SitePromoPopupComponent } from '../site-promo-popup/site-promo-popup.component';
import { AddComparisionArticleComponent } from '../add-comparision-article/add-comparision-article.component';
import { VotesSectionComponent } from './community/member-page/me/nearbyproducts-me/votes-section/votes-section.component';
import { ProductShopComponent } from '../product-shop/product-shop.component';
import { YoutubeIframesComponent } from '../youtube-iframes/youtube-iframes.component';
import { ContributeToProductComponent } from '../contribute-to-product/contribute-to-product.component';
import { DraggableBottomsheetComponent } from '../draggable-bottomsheet/draggable-bottomsheet.component';
import { SearchModalComponent } from '../search-modal/search-modal.component';
import { ComicFeelChatComponent } from '../shareModule/component/comic-feel-chat/comic-feel-chat.component';
import { EditCategoryComponent } from '../edit-category/edit-category.component';
import { EditBookingComponent } from '../edit-category/edit-booking/edit-booking.component';
import { DiscountComponent } from './discount/discount.component';
// import { PageProgressComponent } from '../app-page-progress/page-progress.component';
import { EditCategoryFaqComponent } from '../edit-category/edit-category-faq/edit-category-faq.component';
import { CommonProductChangeTagComponent } from './common/common-product-card-view/common-product-change-tag/common-product-change-tag.component';
import { MapLinksComponent } from '../nearby-map/map-links/map-links.component';
import { ShowBookingsComponent } from '../nearby-map/show-bookings/show-bookings.component';
import { CreateMidCatComponent } from '../create-mid-cat/create-mid-cat.component';
import { EditTypesComponent } from '../edit-types/edit-types.component';
import { EditBookingVariablesComponent } from '../edit-booking-variables/edit-booking-variables.component';
import { AdminSheetComponent } from '../admin-sheet/admin-sheet.component';

class MyErrorHandler implements ErrorHandler {
  handleError(error: Error): void {
    // Only log critical errors
    if (error instanceof HttpErrorResponse && error.status >= 500) {
      console.error('[Critical Error]:', error);
    } else {
      console.error(error)
    }
  }
}

@NgModule({
  declarations: [
    RecommendationCardComponent,
    ProductReviewComponent,
    ManualReviewTaskComponent,
    UploadEditedImageComponent,
    SelectProductToAttachComponent,
    SelectForumModalComponent,
    FormForumComponent,
    CompareProductListComponent,
    SingleForumComponent,
    BreadcrumbComponent,
    VerifyEmailPopupComponent,
    ProductFaqListComponent,
    ProductTypesListComponent,
    TagSelectorComponent,
    LinkShareComponent,
    VidplayerComponent,
    RecommendationsFormComponent,
    RecommendPageComponent,
    BizNameCardComponent,
    PrivacyPolicyComponent,
    ContactUsComponent,
    SettingProfileComponent,
    ForumComponent,
    ForumProfilePopupComponent,
    PollComponent,
    GiveawayComponent,
    GiveawaySurveyComponent,
    SingleNewComponent,
    FormNewComponent,
    NotificationComponent,
    AllNotificationsModalComponent,
    NotificationBookingComponent,
    MarketplaceProfileComponent,
    MarketplaceProfileCharacterComponent,
    GoogleMapComponent,
    ClickOutsideDirective,
    CommonFooterComponent,
    MarketplacePageComponent,
    MarketplaceShopDetailComponent,
    NewsComponent,
    BizCardComponent,
    BulletinComponent,
    CustomersLayoutComponent,
    CustomersLayoutReferralComponent,
    ChatComponent,
    ChatBotComponent,
    ImageModalComponent,
    ReportChatMessageModalComponent,
    ChatLearnComponent,
    ChatMemoryComponent,
    RolesComponent,
    TabForumComponent,
    NewsForumComponent,
    MemberPageComponent,
    CommunitySearchComponent,
    CommunityTrendingComponent,
    CommunityProfileComponent,
    CommunityYoutubeComponent,
    CommunityEatComponent,
    CommunitySpecialTopicComponent,
    HeaderSearchMapComponent,
    FilterProductsComponent,
    SiteLinksComponent,
    SearchComponent,
    ProfileMeComponent,
    AskMeComponent,
    NewsMeComponent,
    AddMeComponent,
    NearbyproductsMeComponent,
    MemberProfileCharacterComponent,
    EventsComponent,
    OnlineToggleButtonComponent,
    IndividualRentalComponent,
    IndividualAllProductComponent,
    IndividualFreeComponent,
    IndividualServicesComponent,
    IndividualEventsComponent,
    OtherCommuntyPageComponent,
    BuyComponent,
    SellComponent,
    ReferComponent,
    WriteArticlesComponent,
    LevelProfileComponent,
    AvatarProfileComponent,
    StoreProfileComponent,
    MyTabsComponent,
    MemberShopComponent,
    LoudspeakerShopComponent,
    TimerComponent,
    ShopPageComponent,
    HowToEarnComponent,
    SignInComponent,
    TermsOfServiceComponent,
    TermsOfRentalComponent,
    MemberRegionSelectModalComponent,
    MemberProfileRolesComponent,
    CarouselMiniCardComponent,
    DiamondsPopupComponent,
    OtpInputComponent,
    PDPAPolicyComponent,
    ViewProductDetailsComponent,
    SurveyComponent,
    AroundeMeComponent,
    DropdownStatusComponent,
    JobCompleteCofirmationModalComponent,
    SideLeftMenuComponent,
    AdvancedSettingsComponent,
    AdvancedSettingsReferralComponent,
    AdvancedSettingsIntroComponent,
    AdvancedSettingsContributionComponent,
    FaqComponent,
    FaqItemComponent,
    PatchNoteComponent,
    BizOwnerPopupComponent,
    MarketplaceProductComponent,
    BizLayoutComponent,
    HowItWorksComponent,
    ForumListComponent,
    NearbyAllServicesComponent,
    AdvancedSettingsProfileComponent,
    AdvancedSettingsPasswordComponent,
    AdvancedSettingsVerifyComponent,
    AdvancedSettingsPreferencesComponent,
    AdvancedSettingsTagsComponent,
    AdvancedSettingsSuperSellerComponent,
    AdvancedSettingsSuperSellerSettingsComponent,
    AdvancedSettingsChatComponent,
    AdvancedSettingsSeoComponent,
    MyProductEditComponent,
    AdvancedSettingsCheckoutHistoryComponent,
    SelectRegionComponent,
    NearbyMapComponent,
    CustomizationColorsComponent,
    // ShowBookingsComponent,
    SearchSuggestionComponent,
    MenuOptionsComponent,
    CustomizationComponent,
    ProfileNewsComponent,
    PromoCardComponent,
    WhatIsKachiingComponent,
    PollCardComponent,
    PollFormComponent,
    SitePromoPopupComponent,
    AddComparisionArticleComponent,
    VotesSectionComponent,
    ProductShopComponent,
    YoutubeIframesComponent,
    ContributeToProductComponent,
    DraggableBottomsheetComponent,
    SearchModalComponent,
    ComicFeelChatComponent,
    EditCategoryComponent,
    EditBookingComponent,
    DiscountComponent,
    // PageProgressComponent,
    EditCategoryFaqComponent,
    CommonProductChangeTagComponent,
    CreateMidCatComponent,
    EditTypesComponent,
    EditBookingVariablesComponent,
    AdminSheetComponent,
    // MapLinksComponent
  ],
  imports: [
    NgOptimizedImage,

    NgxIntlTelInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    CustomersRoutingModule,
    CarouselModule,
    CKEditorModule,
    ShareModule,
    CommonModule,
    // NgxPopperjsModule.forRoot(),
    MatBottomSheetModule,
    ImageCropperComponent,
  ],
  exports: [CommonModule, ViewProductDetailsComponent],
  providers: [
    provideHttpClient(withJsonpSupport()),
    { provide: ErrorHandler, useClass: MyErrorHandler }
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class CustomersModule {
  constructor() { }
}
